import RhinocerosAcademy from '@components/LocalMerchant/RhinocerosAcademy'

export default {
  path: 'rhinocerosAcademy',
  component: RhinocerosAcademy,
  stat: '犀牛学院'
}
